import currencies from './currencies.json';
import _ from 'lodash';

export default angular
  .module('doxy.common.services.currencyService', [])
  .service('currencyService', function () {
    return {
      getCurrencies() {
        return currencies;
      },
      getCurrenciesArray() {
        return _.map(currencies, (name, code) => {
          return {
            code: code,
            name: name,
          };
        });
      },
    };
  }).name;
